import React, { useContext, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft, ChevronRight, ShoppingCart } from 'lucide-react';
import { useEffect } from 'react';
import axios from "axios";
import { product_uri } from '../../../../uri';
import { baseUrlLink } from '../../../../utils/type';
import { Spinner, useToast } from '@chakra-ui/react';
import { AuthContext } from '../../../../context/auth';

const BelenDetail = () => {
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(0);
  const [product, setProducts] = useState({});
  const [load, setLoad] = useState(false);
  const toast = useToast();
  const {currentUser} = useContext(AuthContext);
  const nav = useNavigate();

  useEffect(() => {
    Get();
  }, []);

  const Get = async()=> {
    try{
      const res = await axios.get(product_uri+`/id?id=${id}`)
      setProducts(res.data)
    }catch(err){
      console.log(err);
    }
  }

  const Sub = async() => {
    if(Number(product.stock) == 0){
      return toast({title: "Үлдэгдэл хүрэхгүй байна", status: "warning", duration: 3000,isClosable: true,});
    }
    if(product.sizes.length > 0 && !selectedSize){
      return toast({title: "Хэмжээ сонгоно уу!", status: "warning", duration: 3000,isClosable: true,});
    }
    if(product.colors.length > 0 && !selectedColor){
      return toast({title: "Өнгө сонгоно уу!", status: "warning", duration: 3000,isClosable: true,});
    }
    setLoad(true);
    try{
      const siz = product.sizes.filter(it => it.value == selectedSize);
      const res = await axios.post(product_uri+`/cart`, {
        user_id: currentUser, 
        product_id: product.id, 
        quantity: quantity, 
        size_id: siz[0]?.id, 
        color_id: selectedColor
      });
      if(res.status == 200){
        toast({title: "Сагсанд амжилттай нэмэгдлээ", status: "success", duration: 3000,isClosable: true,});
      }
      setLoad(false);
    }catch(err){
      setLoad(false);
      console.log(err);
      if(err.response.status === 444){
        nav("/login");
      }
    }
  }
  // user_id, product_id, quantity, size_id, color_id
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === product.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? product.images.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  const increaseQuantity = () => {
    if(Number(product.stock) <= Number(quantity)){
      return toast({title: "Үлдэгдэл хүрэхгүй байна", status: "warning", duration: 3000,isClosable: true,});
    }
    setQuantity(prev => prev + 1);
  };

  const decreaseQuantity = () => {
    setQuantity(prev => prev > 1 ? prev - 1 : 1);
  };

  return (
    <div className="text-black mt-8 max-w-2xl mx-auto px-4">
      <Link to="/product" className="text-sm flex items-center hover:text-gray-600 mb-4"> 
        <ChevronLeft size={16} />
        <span>Буцах</span>
      </Link>
      
      {/* Image Slider */}
      <div className="relative">
        <div className="relative h-80 w-full">
          {product.images && product.images.length > 0 ? (
            <img
              src={baseUrlLink + product.images[currentIndex].url}
              alt={`${product.name} - Зураг ${currentIndex + 1}`}
              className="rounded-xl w-full h-80 object-cover"
            />
          ) : (
            <div className="h-80 flex items-center justify-center bg-gray-100 rounded-xl">
              Зураг байхгүй байна
            </div>
          )}
          {/* Navigation Arrows */}
          {product.images && product.images.length > 0 && (
            <>
              <div className="absolute inset-y-0 left-0 flex items-center">
                <button 
                  onClick={prevSlide}
                  className="bg-white bg-opacity-50 hover:bg-opacity-70 rounded-full p-2 ml-2"
                >
                  <ChevronLeft size={20} />
                </button>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center">
                <button 
                  onClick={nextSlide}
                  className="bg-white bg-opacity-50 hover:bg-opacity-70 rounded-full p-2 mr-2"
                >
                  <ChevronRight size={20} />
                </button>
              </div>
            </>
          )}
        </div>

        {/* Thumbnail Navigation */}
        {product.images && product.images.length > 0 && (
          <div className="flex justify-center mt-4 space-x-2">
            {product.images.map((_, idx) => (
              <button
                key={idx}
                onClick={() => goToSlide(idx)}
                className={`h-2 w-2 rounded-full ${currentIndex === idx ? 'bg-black' : 'bg-gray-300'}`}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </div>
        )}
      </div>


      {/* Product Details */}
      <div className="mt-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">{product.name}</h1>
          {Number(product.stock) > 0 ? (
            <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded">
              Бэлэн
            </span>
          ) : (
            <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded">
              Дууссан
            </span>
          )}
        </div>
        
        <p className="mt-2 text-gray-600">{product.description}</p>
        <p className="mt-2 text-gray-600">Үлдэгдэл: {product.stock}</p>
        
        <div className="mt-4">
          <h2 className="font-semibold text-lg">Үнэ: {product.price}₮</h2>
        </div>

        {/* Size Selection */}
        {
          product?.sizes?.length > 0 &&
          <div className="mt-6">
            <h2 className="font-semibold mb-2">Хэмжээ сонгох</h2>
            <div className="flex flex-wrap gap-2">
              {
                product?.sizes?.map((it, index) => {
                  return(
                    <button
                      key={index}
                      onClick={() => setSelectedSize(it?.value)}
                      className={`w-12 h-10 rounded border ${
                        selectedSize === it?.value
                          ? 'border-black bg-black text-white'
                          : 'border-gray-300 hover:border-black'
                      }`}
                    >
                      {it?.value}
                    </button>
                  )
                })
              }
            </div>
          </div>
        }
        

        {/* Color Selection */}
        {
          product?.colors?.length > 0 &&
          <div className="mt-6">
            <h2 className="font-semibold mb-2">Өнгө сонгох</h2>
            <div className="flex gap-2">
              {product.colors?.map((color, idx) => (
                <>
                  <button
                    key={idx}
                    onClick={() => setSelectedColor(color.id)}
                    style={{ backgroundColor: color.code }}
                    className={`w-8 h-8 rounded-full ${
                      selectedColor === color.id ? 'ring-2 ring-offset-2 ring-blue-500' : ''
                    }`}
                    title={color.name}
                  />
                </>
              ))}
            </div>
          </div>
        }

        {/* Quantity Selection */}
        <div className="mt-6">
          <h2 className="font-semibold mb-2">Тоо хэмжээ</h2>
          <div className="flex items-center">
            <button 
              onClick={decreaseQuantity}
              className="w-8 h-8 border border-gray-300 flex items-center justify-center rounded-l"
            >
              <span className="text-lg">-</span>
            </button>
            <div className="w-12 h-8 border-t border-b border-gray-300 flex items-center justify-center">
              {quantity}
            </div>
            <button 
              onClick={increaseQuantity}
              className="w-8 h-8 border border-gray-300 flex items-center justify-center rounded-r"
            >
              <span className="text-lg">+</span>
            </button>
          </div>
        </div>

        {/* Add to Cart Button */}
        <div className="mt-8 mb-8">
          {
            load?
            <button
              className="w-full py-3 rounded-lg font-semibold flex items-center justify-center gap-2 bg-gray-300 text-gray-500 cursor-not-allowed"> 
              <Spinner />
            </button>
            :
            <button
              onClick={Sub}
              className={`w-full py-3 rounded-lg font-semibold flex items-center justify-center gap-2 bg-red-600 text-white hover:bg-red-600 transition-colors'
              }`}
            >
              <ShoppingCart size={20} />
              Сагсанд нэмэх
            </button>

          
          }
        </div>
      </div>
    </div>
  );
};

export default BelenDetail;